compiler('[data-custom-shipping-date]', (element) => {
  const shippingSelectDropdown = document.getElementById("shipping_select_dropdown");
  const deliveryDateSelectOptions = document.querySelectorAll("#delivery_date_select a");
  const showSelection = element.dataset.customShippingDate === "true"

  element.addEventListener('click', (event) => {
    if(showSelection) {
      event.preventDefault();
      shippingSelectDropdown.classList.remove("d-none");
      let url = element.href + (element.href.includes('?') ? '&' : '?')
      deliveryDateSelectOptions.forEach((option) => {
        option.href = `${url}shipping_date=${option.dataset.shippingDate}`;
      });
    } else {
      shippingSelectDropdown.classList.add("d-none");
    }
  });
});
